(function(){
  var s=document.createElement('style');
  s.id='ab-fix-v2';
  s.textContent='.header-logo::after,.header-logo__image-container::after{content:none!important;display:none!important}.header-logo,.header-logo__image-container{font-size:unset!important;line-height:unset!important}';
  (document.head||document.documentElement).appendChild(s);
})();

// Purchase reasons injection for product pages
(function() {
  if (!document.querySelector('[data-product]')) return;
  
  const title = document.title || '';
  const tags = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.tags) || [];
  
  // Room size mapping based on product title/URL
  const roomMap = {
    'mini-7000': { size: '16 m²', btu: '7,000' },
    '9000-btu': { size: '22 m²', btu: '9,000' },
    '12000-btu': { size: '30 m²', btu: '12,000' },
    '14000-btu': { size: '40 m²', btu: '14,000' },
    '18000-btu': { size: '50 m²', btu: '18,000' },
  };
  
  let roomInfo = null;
  let isAC = false;
  let isNoHose = false;
  
  for (const [key, val] of Object.entries(roomMap)) {
    if (title.toLowerCase().includes(key) || window.location.pathname.includes(key)) {
      roomInfo = val;
      isAC = true;
      break;
    }
  }
  
  if (title.toLowerCase().includes('tower') || title.toLowerCase().includes('evaporative') || title.toLowerCase().includes('desktop')) {
    isNoHose = true;
  }
  
  if (!roomInfo && !isNoHose) return;
  
  const reasons = [];
  
  if (roomInfo) {
    reasons.push('<span style="color:#16a34a">&#10003;</span> Cools rooms up to ' + roomInfo.size);
    reasons.push('<span style="color:#16a34a">&#10003;</span> Window kit &amp; exhaust hose included');
    reasons.push('<span style="color:#16a34a">&#10003;</span> UK 3-pin plug — ready to use');
    reasons.push('<span style="color:#16a34a">&#10003;</span> Free UK delivery &middot; 2-year warranty');
  } else if (isNoHose) {
    reasons.push('<span style="color:#16a34a">&#10003;</span> No exhaust hose required');
    reasons.push('<span style="color:#16a34a">&#10003;</span> UK 3-pin plug — ready to use');
    reasons.push('<span style="color:#16a34a">&#10003;</span> Low energy consumption');
    reasons.push('<span style="color:#16a34a">&#10003;</span> Free UK delivery &middot; 2-year warranty');
  }
  
  if (reasons.length === 0) return;
  
  const container = document.createElement('div');
  container.id = 'ab-purchase-reasons';
  container.style.cssText = 'display:flex;flex-direction:column;gap:8px;padding:16px 0;border-top:1px solid #e2e8f0;border-bottom:1px solid #e2e8f0;margin:12px 0';
  container.innerHTML = reasons.map(r => '<div style="font-size:0.875rem;color:#334155;line-height:1.5">' + r + '</div>').join('');
  
  // Find the buy button area and insert before it
  const buyButtonArea = document.querySelector('[data-product-details] [data-buy-buttons]') 
    || document.querySelector('.product-form__buttons')
    || document.querySelector('[name="add"]');
  
  if (buyButtonArea) {
    const parent = buyButtonArea.closest('.shopify-section') || buyButtonArea.parentElement;
    parent.insertBefore(container, buyButtonArea);
  }
  
  // Also add secure checkout + returns info below the button
  const trustRow = document.createElement('div');
  trustRow.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:16px;padding:8px 0 0;font-size:0.8125rem;color:#64748b';
  trustRow.innerHTML = '<span>&#128274; Secure checkout</span><span style="color:#cbd5e1">|</span><span>30-day returns &middot; Tracked UK delivery</span>';
  
  if (buyButtonArea) {
    const formParent = buyButtonArea.parentElement;
    formParent.appendChild(trustRow);
  }
})();
